import { supabase } from "../supabaseClient";
import {
  eventNamesOnSquad,
  eventsBySquadFromRows,
} from "./signupAvailability";

export const replaceSquadEvents = async (squadId, eventIds = []) => {
  const { error: deleteError } = await supabase
    .from("squadEvents")
    .delete()
    .eq("squadID", squadId);
  if (deleteError) throw deleteError;
  const ids = [...new Set((eventIds || []).filter(Boolean))];
  if (!ids.length) return;
  const { error: insertError } = await supabase
    .from("squadEvents")
    .insert(ids.map((eventsID) => ({ squadID: squadId, eventsID })));
  if (insertError) throw insertError;
};

export const fetchEventsBySquad = async (squadIds = []) => {
  const ids = (squadIds || []).filter(Boolean);
  if (!ids.length) return {};
  const { data, error } = await supabase
    .from("squadEvents")
    .select("squadID, eventsID")
    .in("squadID", ids);
  if (error) throw error;
  return eventsBySquadFromRows(data || []);
};

export const withSquadEventIds = (squads = [], eventsBySquad = {}) =>
  (squads || []).map((squad) => ({
    ...squad,
    eventIds: eventsBySquad[squad.id] || squad.eventIds || [],
  }));

export const decorateSquadEventNames = async (squads = []) => {
  const ids = squads.map((squad) => squad.id).filter(Boolean);
  let eventsBySquad = {};
  let extraEvents = [];
  if (ids.length) {
    const { data: rows, error } = await supabase
      .from("squadEvents")
      .select("squadID, eventsID")
      .in("squadID", ids);
    if (!error) {
      eventsBySquad = eventsBySquadFromRows(rows || []);
      const extraIds = [
        ...new Set((rows || []).map((row) => row.eventsID).filter(Boolean)),
      ];
      if (extraIds.length) {
        const { data: eventRows } = await supabase
          .from("tournamentEvents")
          .select("id, eventName")
          .in("id", extraIds);
        extraEvents = eventRows || [];
      }
    }
  }
  return squads.map((squad) => {
    const eventIds = eventsBySquad[squad.id] || [];
    return {
      ...squad,
      eventIds,
      eventNames: eventNamesOnSquad(
        { ...squad, eventIds },
        extraEvents,
        eventsBySquad
      ),
    };
  });
};

export const squadEventLabel = (squad, fallback = "No events") =>
  (squad?.eventNames || []).join(" · ") || fallback;
